<template>
    <v-container fill-height fluid grid-list-xl class="pa-3">
        <v-layout wrap>
            <v-flex xs12>
                <v-card class="pb-3">
                    <v-card-title>
                        <div>
                            <h3 class="headline mb-0 mt-0">
                                SM Lookup
                            </h3>
                        </div>
                    </v-card-title>

                    <v-layout row class="ml-3">
                        <v-btn
                            small
                            color="success"
                            class="mb-3"
                            @click="addOption"
                            >Add Option</v-btn
                        >
                        <v-btn
                            small
                            color="success"
                            class="mb-3"
                            v-if="smLookupOptions.some((l) => l.selected)"
                            @click="deleteOptions"
                            >Delete Options</v-btn
                        >
                    </v-layout>

                    <div v-for="(option, index) in newOptions">
                        <v-layout row class="pa-0 ml-3 mb-2">
                            <v-combobox
                                class="width-200 mr-2"
                                v-model="option.type"
                                label="Type"
                                :items="getTypes()"
                                :rules="[rules.required]"
                                ref="type"
                            ></v-combobox>
                            <v-text-field
                                class="width-200 mr-2"
                                v-model="option.value"
                                label="Value"
                                :rules="[rules.required]"
                                ref="value"
                            ></v-text-field>
                            <v-text-field
                                class="width-200"
                                v-model="option.sortOrder"
                                label="Sort Order"
                                type="number"
                            ></v-text-field>
                            <div class="pt-2">
                                <span class="body-2 ml-3 mr-1">Color:</span>
                                <input
                                    type="color"
                                    class="color-picker"
                                    v-model="option.color"
                                    @change="colorChanged(option)"
                                />
                            </div>

                            <v-btn @click="addOption" flat icon color="success">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn
                                @click="removeOption(index)"
                                flat
                                icon
                                color="#f55a4e"
                            >
                                <v-icon>mdi-minus-circle-outline</v-icon>
                            </v-btn>
                        </v-layout>
                    </div>
                    <v-btn
                        color="success"
                        class="ml-3 mt-0 mb-4"
                        @click="saveNewOptions"
                        v-if="newOptions.length"
                        >Save</v-btn
                    >

                    <v-layout row class="pa-0 mb-2 ml-3 font-weight-medium">
                        <div class="width-50"></div>
                        <div class="width-200">Type</div>
                        <div class="width-200">Value</div>
                        <div class="width-200">Sort Order</div>
                        <div class="width-200">Color</div>
                    </v-layout>
                    <v-divider class="pb-0 pt-3"></v-divider>
                    <div v-for="(option, index) in smLookupOptions">
                        <v-layout
                            row
                            class="pa-0 ml-3 mb-0"
                            v-if="!option.editing"
                        >
                            <v-checkbox
                                class="width-50 my-0"
                                hide-details
                                v-model="option.selected"
                                color="success"
                            ></v-checkbox>

                            <div class="width-200 pt-1">
                                {{ option.type }}
                            </div>
                            <div class="width-200 pt-1">
                                {{ option.value }}
                            </div>
                            <div class="width-200 pt-1">
                                {{ option.sortOrder }}
                            </div>
                            <div class="width-200 pt-1">
                                <div
                                    v-if="option.color"
                                    :style="{
                                        backgroundColor: option.color,
                                        width: '26px',
                                        height: '26px',
                                    }"
                                ></div>
                            </div>
                            <v-btn
                                @click="editOption(option)"
                                flat
                                icon
                                class="my-0"
                                color="success"
                            >
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout
                            row
                            class="pa-0 ml-3 mb-0"
                            v-if="option.editing"
                        >
                            <v-combobox
                                class="width-200 mr-2"
                                v-model="option.type"
                                label="Type"
                                :items="getTypes()"
                                :rules="[rules.required]"
                                ref="optionType"
                            ></v-combobox>
                            <v-text-field
                                class="width-200 mr-2"
                                v-model="option.value"
                                label="Value"
                                :rules="[rules.required]"
                                ref="optionValue"
                            ></v-text-field>
                            <v-text-field
                                class="width-200"
                                v-model="option.sortOrder"
                                label="Sort Order"
                                type="number"
                            ></v-text-field>

                            <div class="pt-2">
                                <span class="body-2 ml-2 mr-1">Color:</span>
                                <input
                                    type="color"
                                    class="color-picker"
                                    v-model="option.color"
                                />
                            </div>

                            <v-btn
                                small
                                class="ml-2"
                                color="default"
                                dark
                                style="height: 28px;"
                                @click="rollbackOption(option)"
                                >Cancel</v-btn
                            >
                            <v-btn
                                small
                                color="success"
                                style="height: 28px;"
                                @click="saveOption(option)"
                                >Save</v-btn
                            >
                        </v-layout>
                        <v-divider
                            class="pb-0 pt-3"
                            v-if="index + 1 < smLookupOptions.length"
                        ></v-divider>
                    </div>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import moment from "moment";
import { onlyUnique } from "../../utils/helpers.js";

export default {
    data: () => ({
        smLookupOptions: [],
        newOptions: [],
        processing: false,

        rules: {
            required: (value) => !!value || "Required",
        },
    }),
    async created() {
        await this.loadSmLookup();
    },
    computed: {},
    methods: {
        async loadSmLookup() {
            const response = await this.$http.get(`/odata/smlookup?`);

            const smLookupOptions = response.value
                .map((option) => {
                    option.selected = false;
                    option.editing = false;

                    return option;
                })
                .sort((ob1, ob2) => {
                    if (ob1.type > ob2.type) {
                        return 1;
                    } else if (ob1.type < ob2.type) {
                        return -1;
                    }

                    if (ob1.value < ob2.value) {
                        return -1;
                    } else if (ob1.value > ob2.value) {
                        return 1;
                    } else {
                        return 0;
                    }
                    return 0;
                });

            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            if (roles.includes("Hakol")) {
                this.smLookupOptions = smLookupOptions.filter(
                    (o) =>
                        o.type == "HakolStatus" ||
                        o.type == "HakolCategory" ||
                        o.type == "HakolUser" ||
                        o.type == "HakolBuilding",
                );
            } else {
                this.smLookupOptions = smLookupOptions;
            }
        },
        addOption() {
            this.newOptions.push({
                type: "",
                value: "",
                sortOrder: "",
            });
        },
        removeOption(index) {
            this.newOptions.splice(index, 1);
        },
        editOption(option) {
            option.editing = true;
        },
        getTypes() {
            return this.smLookupOptions
                .map((o) => o.type)
                .filter(onlyUnique)
                .concat(
                    this.newOptions
                        .filter((o) => o.type)
                        .map((o) => o.type)
                        .filter(onlyUnique),
                );
        },
        async deleteOptions() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/smLookup/delete",
                    this.smLookupOptions
                        .filter((s) => s.selected)
                        .map((o) => o.id),
                );

                this.processing = false;

                this.loadSmLookup();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveNewOptions() {
            if (
                !this.$refs.type.some((v) => v.validate(true)) ||
                !this.$refs.value.some((v) => v.validate(true))
            )
                return;

            try {
                this.processing = true;

                await this.$http.post("api/smLookup/save", this.newOptions);

                this.processing = false;

                this.loadSmLookup();

                this.newOptions = [];
            } catch (e) {
                this.processing = false;
            }
        },
        rollbackOption(option) {
            option.editing = false;

            this.loadSmLookup();
        },
        colorChanged(option) {
            console.log(option);
        },
        async saveOption(option) {
            const editingOptions = this.smLookupOptions.filter(
                (s) => s.editing,
            );

            const index = editingOptions.indexOf(option);

            if (
                !this.$refs.optionType[index].validate(true) ||
                !this.$refs.optionValue[index].validate(true)
            )
                return;

            try {
                this.processing = true;

                await this.$http.post("api/smLookup/save", [option]);

                this.processing = false;

                this.loadSmLookup();

                this.newOptions = [];
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style scoped>
.color-picker {
    margin-right: 10px;
    margin-top: 10px !important;
    width: 26px;
    height: 30px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
}
</style>
